import React from 'react';

import { Link, Text } from '@betterment/samba-react';

import urlBuilder from '../../../Shared/url-builder';

export const Disclaimer: React.FC = () => {
  return (
    <Text variant="text50" color="text.weak">
      Betterment’s algorithms are designed to prioritize the order of tax lots and shares to sell, evaluating factors
      such as cost basis and duration held, in order to reduce the tax impact on your client’s investments.{' '}
      <Link href={urlBuilder.getCostBasisAccountingArticle()} variant="textSecondary">
        Learn more
      </Link>
    </Text>
  );
};
